// CSRF token önbelleği — sayfa ömrü boyunca tek seferlik alınır
let cachedToken = null;

export const getCsrfToken = async () => {
  if (cachedToken) return cachedToken;

  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/csrf-token`, {
    credentials: 'include'
  });

  if (!response.ok) throw new Error('CSRF token alınamadı');

  const data = await response.json();
  cachedToken = data.csrfToken;
  return cachedToken;
};

// Sipariş/form submit sonrası token'ı sıfırla (tek kullanımlık senaryolar için)
export const resetCsrfToken = () => {
  cachedToken = null;
};
